// extracted by mini-css-extract-plugin
export default {"btn":"Dropdown--btn--+NbFF","icon":"Dropdown--icon--l5JbB","list":"Dropdown--list--YdZ-n","item":"Dropdown--item--6rPpk"};